import React from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import { Card, CardBody, Container, Row, Col, Button } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { IgarashiCustomerAction } from "store/customer-resource/actions"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import SButton from "components/Common/Button"
import { MetaTags } from "react-meta-tags"
import Skeleton from "react-loading-skeleton"
import TableContainer from "components/newTables/TableContainer"

export default function IndividualCustomerManagement() {
  const dispatch = useDispatch()
  const history = useHistory()
  const store = useSelector(state => state)
  const [pagination, setPagination] = React.useState({
    page: 0,
    size: 10,
  })
  const [params, setParams] = React.useState({
    page: 0,
    size: 10,
  })
  const [filter, setFilter] = React.useState({
    companyName: "",
    branchName: "",
    customerName: "",
    address: "",
  })

  React.useEffect(() => {
    dispatch(IgarashiCustomerAction.getListPage({ ...params, ...pagination }))
  }, [params, pagination])

  const columns = React.useMemo(
    () => [
      {
        Header: "企業名",
        accessor: "companyName",
        disableSortBy: true,
      },
      {
        Header: "店舗名",
        accessor: "branchName",
        disableSortBy: true,
      },
      {
        Header: "コード",
        accessor: "fullCode",
        disableSortBy: true,
      },
      {
        Header: "顧客名",
        accessor: "customerName",
        disableSortBy: true,
      },
      {
        Header: "住所",
        accessor: "address",
        disableSortBy: true,
      },
      {
        Header: "",
        accessor: "action",
        disableSortBy: true,
        Cell: cell => {
          return (
            <SButton
              className="button"
              onClick={() =>
                history.push(
                  `/direct-management-individual-customer-management/${cell.row.original.id}`
                )
              }
            >
              詳細
            </SButton>
          )
        },
      },
    ],
    []
  )

  const onChangeFilter = e => {
    const { name, value } = e.target
    setFilter({
      ...filter,
      [name]: value,
    })
  }

  const onSearch = () => {
    setPagination({ page: 0, size: 10 })
    setParams({
      ...filter,
      page: 0,
      size: 10,
    })
  }

  return (
    <>
      <MetaTags>
        <title>自社顧客管理 | Igarashi Trousers</title>
      </MetaTags>

      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"自社顧客管理"} breadcrumbList={[]} />

          <Card>
            <CardBody>
              <Row>
                <Col lg={2}>
                  <TextInputWithLabel
                    label={"会社名"}
                    placeholder={""}
                    type="text"
                    name="companyName"
                    onChange={onChangeFilter}
                    value={filter.companyName}
                  />
                </Col>
                <Col lg={2}>
                  <TextInputWithLabel
                    label={"店舗名"}
                    placeholder={""}
                    type="text"
                    name="branchName"
                    onChange={onChangeFilter}
                    value={filter.branchName}
                  />
                </Col>
                <Col lg={2}>
                  <TextInputWithLabel
                    label={"顧客名"}
                    placeholder={""}
                    type="text"
                    name="customerName"
                    onChange={onChangeFilter}
                    value={filter.customerName}
                  />
                </Col>
                <Col lg={2}>
                  <TextInputWithLabel
                    label={"個人住所"}
                    placeholder={""}
                    type="text"
                    name="address"
                    onChange={onChangeFilter}
                    value={filter.address}
                  />
                </Col>
                <Col lg={2} className="align-self-end">
                  <SButton onClick={() => onSearch()} className="button">
                    検索
                  </SButton>
                </Col>
              </Row>
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              <Row className="mb-3">
                <Col sm="6" />
                <Col
                  sm="6"
                  className="d-flex align-items-end justify-content-end"
                >
                  <Button
                    className="button"
                    onClick={() =>
                      history.push(
                        `/direct-management-individual-customer-management/add`
                      )
                    }
                  >
                    新規顧客追加
                  </Button>
                </Col>
              </Row>

              <Row className="mb-2">
                {store.customer.pagesIgarashi.loading ? (
                  <Skeleton count={5} />
                ) : store.customer.pagesIgarashi.data?.content?.length === 0 ? (
                  <h3 className="text-center">No Data to Display</h3>
                ) : (
                  <TableContainer
                    data={store.customer.pagesIgarashi.data?.content || []}
                    columns={columns}
                    pagination
                    page={pagination.page}
                    size={pagination.size}
                    count={store.customer.pagesIgarashi.data?.totalPages || 1}
                    setParams={setPagination}
                    params={pagination}
                  />
                )}
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  )
}
